import { Calendar } from 'lucide-react'

import { UnderlinedTooltip } from 'components/ui/UnderlinedTooltip'
import { getLocaleDateString } from 'utils'

type CoverageDetailsSectionProps = {
  coverageStartDate: string
  requestedStartDate?: string
  headerVariant?: 'full' | 'compact'
}

const CoverageDetailsSection = ({
  coverageStartDate,
  requestedStartDate,
  headerVariant = 'full',
}: CoverageDetailsSectionProps) => {
  const headerText = headerVariant === 'full' ? 'Coverage Details:' : 'Details:'

  return (
    <div className='space-y-2'>
      <h6 className='font-medium text-sm text-gray-600'>{headerText}</h6>
      <div className='flex items-center space-x-2'>
        <Calendar className='w-4 h-4 text-blue-500' />
        <span className='text-sm text-gray-600'>
          <UnderlinedTooltip
            className='inline'
            content={
              <div className='max-w-xs p-2 text-sm'>
                The date coverage should start/started for the insurance enrollment this workflow affects.
              </div>
            }
          >
            Coverage starts
          </UnderlinedTooltip>{' '}
          {getLocaleDateString(new Date(coverageStartDate))}
        </span>
      </div>
      {requestedStartDate && (
        <div className='flex items-center space-x-2'>
          <Calendar className='w-4 h-4 text-amber-500' />
          <span className='text-sm text-gray-500'>
            <UnderlinedTooltip
              className='inline'
              content={
                <div className='max-w-xs p-2 text-sm'>
                  The target date when the changes this workflow makes should go into effect.
                </div>
              }
            >
              Requested Start Date
            </UnderlinedTooltip>{' '}
            {getLocaleDateString(new Date(requestedStartDate))}
          </span>
        </div>
      )}
    </div>
  )
}

export default CoverageDetailsSection
